export default {"src":"/_next/static/media/m_logotype.579054ca.svg","height":23,"width":122,"blurWidth":0,"blurHeight":0};